import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { TextButton } from '@xingternal/button';
import { IconArrowDown, IconArrowUp } from '@xingternal/icons';
import { spaceM, spaceXS, xdlColorBackground } from '@xingternal/tokens';

const DEFAULT_TOGGLE_TOP_MARGIN = '0';

type ToggleButtonProps = {
  $topMargin?: string;
};

const ToggleButton = styled(TextButton)<ToggleButtonProps>(
  ({ $topMargin }) => css`
    background: ${xdlColorBackground};
    min-height: ${spaceM};
    padding: 0 ${spaceXS};
    position: relative;
    width: 100%;
    margin-top: ${$topMargin};
  `
);

type Props = {
  initiallyExpanded?: boolean;
  onToggle?: (isExpanded: boolean) => void;
  textCollapsed: string;
  textExpanded: string;
  collapsedHeight?: number;
  toggleTopMargin?: string;
};

export const ShowMore: React.FC<Props> = ({
  children,
  initiallyExpanded = false,
  onToggle,
  textCollapsed,
  textExpanded,
  collapsedHeight = 0,
  toggleTopMargin = DEFAULT_TOGGLE_TOP_MARGIN,
}) => {
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded);
  const styles = isExpanded
    ? { height: 'auto', overflow: 'initial' }
    : { height: collapsedHeight + 'px', overflow: 'hidden' };

  const onClick = (): void => {
    setIsExpanded(!isExpanded);
    onToggle && onToggle(!isExpanded);
  };

  return (
    <>
      <div style={styles}>{children}</div>
      <ToggleButton
        icon={isExpanded ? IconArrowUp : IconArrowDown}
        iconAfter
        size="medium"
        onClick={onClick}
        $topMargin={toggleTopMargin}
      >
        {isExpanded ? textExpanded : textCollapsed}
      </ToggleButton>
    </>
  );
};
